import { ErrorHandler, Injectable } from '@angular/core';
import { LogService } from '../diagnostics/log.service';
import { HttpErrorResponse } from '@angular/common/http';
import { environment } from 'src/environments/environment';

@Injectable()
export class GlobalErrorHandler implements ErrorHandler {
  private readonly logService: LogService;
  private isProd: boolean;

  public constructor(logginService: LogService) {
    this.logService = logginService;
    this.isProd = environment.production;
  }

  public handleError(error: Error) {
    if (!this.isProd) {
      console.error(error);
      throw error;
    }

    error = this.filterError(error);

    if (error == null) {
      return;
    }

    const userAgent =
      window.navigator != null ? window.navigator.userAgent : '';

    // Log  the error
    this.logService
      .error<GlobalErrorHandler>(this.getCategory(error), error, userAgent)
      .subscribe(() => {
        console.log('logged');
      });
  }

  private filterError(error: Error): Error {
    if (error == null) {
      return null;
    }

    // Filter out non critical known errors.
    if (error instanceof HttpErrorResponse) {
      // Known issue, when user not logged in. We must remove the call to player, when not logged in.
      if (
        error.status === 403 &&
        error.message.indexOf('/api/player') > 0
      ) {
        return null;
      }

      // Safe guard to avoid infinite loops if connection to log service itself breaks.
      if (error.message.indexOf('/log/error') > 0) {
        return null;
      }
    }

    return error;
  }

  private getCategory(error: Error): string {
    switch (true) {
      case error instanceof HttpErrorResponse: return 'HTTP';
    }

    return 'UNKNOWN';
  }
}
